import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionnaireCreateInput } from '../generated/globalTypes';
import { createQuestionnaireMutation, createQuestionnaireMutationVariables } from '../generated/createQuestionnaireMutation';
import { questionnaireFieldsFragment } from '../models/Questionnaire';

/**
 * Get a callback to create a Questionnaire in the store.
 */
export function useCreateQuestionnaireCallback(): [(model: QuestionnaireCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createQuestionnaireMutation, createQuestionnaireMutationVariables>(
        gql`
            mutation createQuestionnaireMutation ($model: QuestionnaireCreateInput!) {
                createQuestionnaire(model: $model) {
                    ...questionnaireFields
                }
            }

            ${questionnaireFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: QuestionnaireCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
